import * as React from "react";
import { connect } from "react-redux";
import Spinner from "../common/spinner";
import SelectPatient from "../common/SelectPatient";
import * as d from "../../reducers/domainReducer";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import * as types from "../../constants/actionTypes";
import { Redirect } from 'react-router-dom';
import NoProxy from '../common/NoProxy';

class VideoVisit_ProxySelector extends React.Component {
    constructor(props) {
        super(props);
        this.ourCallback = this.ourCallback.bind(this);
        this.state = { activeUserIndex: 0, userSelected: null };
    }

    componentDidMount() {
        logUI("MBHWeb.UI.VideoVisit.ProxySelector.ComponentDidMount", new Date(), Tools.getURLPath());        
    }   

    onUserSelected = userSelected => {
        this.selectedUser = userSelected;
        this.ourCallback();
    };

    ourCallback() {
        this.props.history.push({
            pathname: "/videovisitoptions",
            state: { selectedUser: this.selectedUser } //may be this is not required as it could be only current user if not proxy user.
        });
    }

    onUserSwitched = (userSelected, index) => {        
        this.props.switchToMyChartUser(userSelected, index, () => {
            window.userToSwitch = userSelected;
            this.ourCallback();
        });
    }

    onSkipProxy = (isAddDependentSkipped) => {
        this.setState({ isAddDependentSkipped });
    }

    render() {
        const { failure, currentUser, myProxies, proxyListLoaded, hasMychart, age, serverData, showDependentProxyForm  } = this.props;
        const { userSelected } = this.state;
        const isProxyAvailable = hasMychart && myProxies && myProxies.length > 1 ? true : false;
        const message = "Who is this visit for?";
        const isAdult = age && age > 17 ? true : false;

        let body = null;
        if (!failure && !proxyListLoaded) {
            body = (<div className="row">
                <div className="col-12 maxWidth-content">
                    <Spinner />
                </div>
            </div>);
        }        
        else if (!userSelected) {
            body = (<><div className="row">
                {isProxyAvailable &&
                    <SelectPatient
                        message={message}
                        myProxies={myProxies}
                        currentUser={currentUser}
                        switchToMyChartUser={this.onUserSwitched}
                        hasMychart={hasMychart}
                        isAdult={isAdult}
                        activityCode="MBHWeb.UI.VideoVisit.ProxySelector.AddDependent.Clicked"
                        className="col-12 maxWidth-content video-visit-proxy-selector"
                        serverData={serverData}
                        onUserSelected={this.onUserSelected}
                        iconLeftClass="svg-schedule-color"/>
                    
                }
            </div>
                {!isProxyAvailable ? showDependentProxyForm && hasMychart && isAdult
                    ? <NoProxy message={message} myProxies={myProxies} currentUser={currentUser} switchToMyChartUser={this.onUserSwitched}
                        stepHeading={"Did you know?"} titleInfo={"You can do a Visit for a dependent ages 2-17."} iconRightClass={"svg-dependent"} serverData={serverData}
                        savePreferenceCall={this.props.savePreferenceCall} onSkipProxy={this.onSkipProxy}
                        onActionTaken={(actionTaken) => { this.actionTaken = actionTaken; }} onUserSelected={this.onUserSelected}
                        activityCode="MBHWeb.UI.VideoVisit.ProxySelector.NoProxy.AddDependent.Clicked"
                    />
                    : <Redirect to="/videovisitoptions" /> : ""}
            </>
            );
        }

        return (
            <div className="container-fluid body-content">
                {body}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const pl = [];
    if (state.domain.pl) {
        state.domain.pl.forEach((proxy) => {
            pl.push(d.hydrateProxyUser(proxy));
        });
    }
    return {       
        failure: state.memberships.proxyListFailure,
        primaryUser: d.hydrateProxyUser(state.domain.pu),
        currentUser: d.hydrateProxyUser(state.domain.cu),
        serverData: state.session.serverData,        
        myProxies: pl,        
        history: state.session.history,
        hasMychart: state.domain.hm,
        proxyListLoaded: state.memberships.proxyListLoaded,        
        age: state.domain.age,
        showDependentProxyForm: state.session.showDependentProxyForm
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        switchToMyChartUser: (user, index, callback) => {
            dispatch({ type: types.SWITCH_USER_SAGA, user, index, callback });
        },
        savePreferenceCall: () => {
            dispatch({
                type: types.UPDATE_ADD_DEPENDENT_PROXY_PREFERENCE
            });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoVisit_ProxySelector);